import React, { ReactElement } from "react";

import "./HiddenMessage.scss";

interface HiddenMessageProps {
  id: string;
  message: ReactElement | string;
}

export const HiddenMessage = ({ id, message }: HiddenMessageProps) => {
  return (
    <div className="hidden-message" aria-hidden="true" id={id}>
      {message}
    </div>
  );
};
